export const authGateStrings = {
  loading: 'Cargando...',
  noAccessTitle: 'Sin acceso',
  noAccessBody:
    'Tu cuenta inició sesión correctamente, pero no tiene acceso a este sistema. Contacta a tu administrador para que la habilite.',
  noAccessSignOut: 'Cerrar sesión',
} as const
